import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ApiHelper} from "../../helpers/ApiHelper";
import { getCredential } from "../../helpers/CommonHelper";

const baseUrl = '/api/users';
export const defaultFieldValues = {"userId": "", "password": ""};
const initialState = {content: [], params: defaultFieldValues, status: 'idle'}

export const login = createAsyncThunk('login/login',
    params => ApiHelper.login(`${baseUrl}/login`, params))

export const logout = createAsyncThunk('login/logout',
    () => ApiHelper.logout(`${baseUrl}/logout`))


const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        saveParams: ApiHelper.saveParams,
    }, extraReducers: {
        [login.fulfilled]: ApiHelper.loginResponse,
        [login.pending]: ApiHelper.pending,
        [login.rejected]: ApiHelper.idle,
        [logout.fulfilled]: ApiHelper.logoutResponse,
        [logout.pending]: ApiHelper.pending,
        [logout.rejected]: ApiHelper.idle,
    }
})

export const credentials = (state) => {
    const credential = state.login?.credentials;
    if(credential) {
        return credential;
    }
    return getCredential();
}

export const {saveParams} = loginSlice.actions

export default loginSlice.reducer